// Instant meal PDP / quick-add price estimates (display-only). Cart remains the authority at checkout.
// Per-meal discounts (1-based meal index in the cart after the add):
//   meal 1 → $0 off
//   meal 2 → shop metafield custom.discount_meals_tier_1 (via MealPricingEstimateConfig)
//   meal 3+ → shop metafield custom.discount_meals_tier_2 each
// ATC for adding `qty` meals = list − sum of per-meal discounts for indices (cartMeals+1)…(cartMeals+qty)
// Amounts are seeded from snippets/meal-pricing-estimate-config.liquid (dollars → cents).

(function () {
  const cfg = window.MealPricingEstimateConfig || {};

  window.MealPricingEstimate = {
    TWO_MEAL_OFF_CENTS: cfg.TWO_MEAL_OFF_CENTS != null ? cfg.TWO_MEAL_OFF_CENTS : 800,
    EACH_ADDITIONAL_OFF_CENTS: cfg.EACH_ADDITIONAL_OFF_CENTS != null ? cfg.EACH_ADDITIONAL_OFF_CENTS : 1600,
    // Cart may hold this many our-meals (16 is allowed; 17+ is not).
    MAX_MEALS_IN_CART: cfg.MAX_MEALS_IN_CART != null ? cfg.MAX_MEALS_IN_CART : 16,
    // Non-meal PDP/sticky stepper: max qty selected in one add (not a cart total).
    MAX_ADDON_QTY: cfg.MAX_ADDON_QTY != null ? cfg.MAX_ADDON_QTY : 16,
    SERVINGS_PER_MEAL: 2,

    formatMoney(cents) {
      const dollars = cents / 100;
      return Number.isInteger(dollars) ? '$' + dollars : '$' + dollars.toFixed(2);
    },

    remainingMealSlots(cartMealCount) {
      const inCart = Math.max(0, Math.floor(Number(cartMealCount)) || 0);
      return Math.max(0, this.MAX_MEALS_IN_CART - inCart);
    },

    isMealCartAtLimit(cartMealCount) {
      return this.remainingMealSlots(cartMealCount) <= 0;
    },

    /**
     * Max qty the stepper may select for this add.
     * Meals: remaining slots until MAX_MEALS_IN_CART (0 when cart is full).
     * Add-ons: MAX_ADDON_QTY (per-selection, independent of cart meals).
     */
    maxSelectableQty(options) {
      const isMeal = Boolean(options && options.isMeal);
      const cartMealCount = options && options.cartMealCount;
      if (isMeal) return this.remainingMealSlots(cartMealCount);
      return this.MAX_ADDON_QTY;
    },

    // Discount applied to the meal at 1-based position `mealNumber` in the cart
    discountCentsForMealNumber(mealNumber) {
      const n = Math.max(0, Math.floor(Number(mealNumber)) || 0);
      if (n <= 1) return 0;
      if (n === 2) return this.TWO_MEAL_OFF_CENTS;
      return this.EACH_ADDITIONAL_OFF_CENTS;
    },

    // Total flat discount for a cart with `mealCount` our-meals items
    volumeDiscountCents(mealCount) {
      const n = Math.max(0, Math.floor(Number(mealCount)) || 0);
      let total = 0;
      for (let i = 1; i <= n; i++) {
        total += this.discountCentsForMealNumber(i);
      }
      return total;
    },

    /**
     * @param {number} qty - meals being added
     * @param {object} options
     * @param {number} options.unitCents - unit price of the product being added
     * @param {number} [options.cartMealCount=0] - our-meals already in cart (seeded on page load)
     */
    estimate(qty, options) {
      const unitCents = Math.max(0, Math.floor(Number(options && options.unitCents)) || 0);
      const cartMealCount = Math.max(0, Math.floor(Number(options && options.cartMealCount)) || 0);
      const meals = Math.max(1, Math.floor(Number(qty)) || 1);

      const listCents = unitCents * meals;
      let discountCents = 0;
      for (let i = 1; i <= meals; i++) {
        discountCents += this.discountCentsForMealNumber(cartMealCount + i);
      }
      const totalCents = Math.max(0, listCents - discountCents);
      const servings = meals * this.SERVINGS_PER_MEAL;
      const perServingCents = servings > 0 ? Math.floor((totalCents + servings / 2) / servings) : 0;

      return {
        qty: meals,
        cartMealCount,
        unitCents,
        totalCents,
        listCents,
        discountCents,
        perServingCents,
      };
    },
  };
})();
